import { Component } from '@angular/core';

@Component({
  selector: 'app-logs-email-log',
  templateUrl: './logs-email-log.component.html',
  styleUrls: ['./logs-email-log.component.scss'],
})
export class LogsEmailLogComponent {}
